"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommandPaletteController", {
    enumerable: true,
    get: function() {
        return CommandPaletteController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _commandpaletteservice = require("~/services/command-palette.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let CommandPaletteController = class CommandPaletteController {
    async commandPalette(req) {
        const data = this.commandPaletteService.commandPalette({
            user: req == null ? void 0 : req.user,
            body: req.body
        });
        return data;
    }
    constructor(commandPaletteService){
        this.commandPaletteService = commandPaletteService;
    }
};
_ts_decorate([
    (0, _common.Post)('/api/v1/command_palette'),
    (0, _extractidsmiddleware.Acl)('commandPalette', {
        scope: 'org'
    }),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], CommandPaletteController.prototype, "commandPalette", null);
CommandPaletteController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _commandpaletteservice.CommandPaletteService === "undefined" ? Object : _commandpaletteservice.CommandPaletteService
    ])
], CommandPaletteController);
